import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { FirstSavingsPlanTeaserBase } from '@zero/depot/feature-depot/base';
import { GuidedTourFacade } from '@zero/guided-tour/domain';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';
import { combineLatest, filter } from 'rxjs';

@Component({
  selector: 'depot-first-savings-plan-teaser',
  templateUrl: './first-savings-plan-teaser.component.html',
  styleUrls: ['./first-savings-plan-teaser.component.scss'],
  imports: [RouterLink, TranslocoPipe, AsyncPipe, ButtonComponent],
})
export class FirstSavingsPlanTeaserComponent extends FirstSavingsPlanTeaserBase {
  readonly #guidedTourFacade = inject(GuidedTourFacade);

  public readonly savingsPlanForm = commonRoutes.postlogin.add_savings_plan;
  public readonly savingsPlanHome = commonRoutes.postlogin.savings_plans;

  public readonly shouldDisplayTeaser$ = combineLatest([
    this.depotFacade.savingsPlanTeaserProducts$,
    this.#guidedTourFacade.showNotification$,
  ]).pipe(filter(([savingsPlanTeaserProducts, showNotification]) => savingsPlanTeaserProducts?.length && !showNotification));
}
